import { httpClient, baseURL } from '@/utils/http-client';
class ImageService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    async getImageList(page, limit) {
        const response = await this.httpClient.get('/image', {
            params: {
                page: page,
                limit: limit
            }
        });
        return response.data;
    }
    async uploadVideo() { }
    async getImageUploadStatus(id) {
        return new EventSource(`${baseURL}/events/image/upload/${id}`);
    }
    async getImage(id) {
        const response = await this.httpClient.get(`/image/${id}`);
        return response.data;
    }
    async getSignedUrl() {
        const response = await this.httpClient.get('/image/upload/signedurl');
        return response.data;
    }
    async saveSignedUrl(filename, name, language) {
        const response = await this.httpClient.post('/image/upload/signedurl', {
            filename,
            name,
            language
        });
        return response.data;
    }
    async deleteVideo(id) {
        return await this.httpClient.delete(`/image/${id}`);
    }
}
export default ImageService;
